<!-- eslint-disable vue/valid-v-for -->
<template>
  <v-sheet flat border class="pa-4 col-sm-12">
    <p class="text-subtitle-1 pt-3 text-primary">
      <span class="font-weight-bold">Energy</span>
      - Input values at execution time
    </p>
    <v-row>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.CurrentDateTime"
          :rules="[isDate]"
          variant="outlined"
          label="Current Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.ReadingDateTime"
          :rules="[isDate]"
          variant="outlined"
          label="Reading Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.DelayInMinutes"
          :rules="[isNumberGreaterThanZero]"
          variant="outlined"
          label="Delay in Minutes"
        />
      </v-col>
    </v-row>
    <BusinessHoursInput
      v-model:start-time="localInputData.SiteStartTime"
      v-model:end-time="localInputData.SiteEndTime"
    />
    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.ElectricityValueKwh"
          :rules="[isNumber]"
          variant="outlined"
          label="Electricity kWh"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.ElectricityValueKw"
          :rules="[isNumber]"
          variant="outlined"
          label="Electricity kW"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.SolarValueKwh"
          :rules="[isNumber]"
          variant="outlined"
          label="Solar kWh"
        />
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.SolarValueKw"
          :rules="[isNumber]"
          variant="outlined"
          label="Solar kW"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <v-text-field
          v-model="localInputData.OutSiteTemperature"
          :rules="[isNumber]"
          variant="outlined"
          label="Outside Air Temperature"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import {
  isNumber,
  isNumberGreaterThanZero,
  hasValue,
  isDate,
} from '@/Core.Patterns/Factory/validationFactory.ts';
import BusinessHoursInput from '@/Core.Service.Domain/Strategies/Strategies/Components/BusinessHoursInput.vue';
import { withBaseInputDefaults } from '@/Core.Service.Domain/Strategies/Strategies/Utils/baseInputDefaults.ts';

export default {
  name: 'FiveMinutesTotalEnergyWithWeatherInput',

  components: { BusinessHoursInput },

  props: {
    InputData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      localInputData: withBaseInputDefaults(this.InputData),
    };
  },

  watch: {
    localInputData: {
      handler(newVal) {
        this.$emit('update:model', newVal);
      },
      deep: true,
    },
  },

  methods: {
    isNumber,
    isNumberGreaterThanZero,
    hasValue,
    isDate,
  },
};
</script>
